import axios from "axios";

const state = {
    orders:[],
    order : {},
    tracking : {},

    index:'',
    sortBy:'',
    sortDesc:'',
    setting:{},
    enableAgents: false


};

const getters = {
    getOrders: state => {
        return state.orders;
    },
    getOrder: state => {
        return state.order;
    },
    getTracking: state => {
        return state.tracking;
    },
    getIndex: state => {
        return state.index;
    },
    getSortBy: state => {
        return state.sortBy;
    },
    getSortDesc: state => {
        return state.sortDesc;
    },
    getSetting: state => {
        return state.setting;
    },

};

const actions = {
    asyncFetchData : async (context,settings) => {

         context.commit('setSetting', settings);
         const {sortBy, sortDesc, page, itemsPerPage} = settings.options;
         let url = "shippings/monitor";
         context.commit('setSortDesc', sortDesc[0]);
         context.commit('setSortBy', sortBy[0]);
         return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
                {
                    'data': {
                        "sortBy": sortBy[0],
                        'sortDesc': sortDesc[0],
                        'page': page,
                        'itemsPerPage': itemsPerPage,
                        'filters': (settings.filters)?settings.filters:'',
                        'search': settings.search
                    }
                },
                {
                    'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                    "Content-Type": "application/json"
                },
            )

                .then(res => {
                    //console.log(res.data.pagination);
                    context.commit('setOrders', res.data.data);
                    return res.data.pagination
                    //resolve(res);
                })
                .catch(err => {
                    console.log("errore", err);
                    /*if (err.response.status === 401) {

                        //this.setLogout();
                        context.commit('profile/setLogout', {}, {root: true})
                        this.$router.push('/login')
                    }
                    throw Error(err.response.status + ":Posts Not Found");*/
                });

    },
    handleMonitor : async (context,payload) => {

        let url = "shippings/handle-monitor";

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload,
          {
              'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
              "Content-Type": "application/json"
          },
        )
          .then(res => {
              return res.data
          })
          .catch(err => {
              console.log("errore", err);
          });

    },
    getTracking : async (context,payload) =>{
        //console.log(payload)
        let url = `shippings/tracking`;


        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            payload,

            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                //console.log(res);
                //context.commit('setPackaging', res.data.data);
                return {data:res.data.trackings}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*  if (err.response.status === 401) {

                      //this.setLogout();
                      context.commit('profile/setLogout', {}, {root: true})
                      this.$router.push('/login')
                  }
                  throw Error(err.response.status + ":Posts Not Found");*/
            });
    },

    destroyData : (context) =>{
        context.commit('setOrders',[]);
        context.commit('setOrder',[]);
        context.commit('setIndex','');
        context.commit('setTracking',{});
    },







};

const mutations = {
    setOrders: (state,value) => {
        state.orders= value;
    },
    setOrder: (state,value) => {
        state.order= value;
    },
    setTracking: (state,value) => {
        state.tracking= value;
    },
    setIndex: (state,value) => {
        state.index= value;
    },
    setSortBy: (state,value) => {
        state.sortBy= value;
    },
    setSortDesc: (state,value) => {
        state.sortDesc= value;
    },
    setSetting: (state,value) => {
        state.setting= value;
    },



};



export default {
    namespaced : true,
	state,
	mutations,
	getters,
	actions
}
